import * as React from 'react';

const { Alerts } = require('@cvent/carina-alert');

const styles = require('../CheckOutPage.module.scss');

const SuccessAlert = () => {
    const [shouldShowAlert, setShouldShowAlert] = React.useState<boolean>(true);
    React.useEffect(() => {
        const timeout = setTimeout(() => {
            setShouldShowAlert(false);
        }, 5000);
        return () => {
            clearTimeout(timeout);
        };
    }, []);

    if (!shouldShowAlert) {
        return null;
    }

    return (
        <div className={styles.alertWrapper}>
            <Alerts
                alerts={[
                    {
                        appearance: 'success',
                        text: <p>Your message was sent</p>,
                        dismissible: true,
                        id: '0',
                        onDismiss: () => {
                            setShouldShowAlert(false);
                        },
                    },
                ]}
            />
        </div>
    );
};

export default SuccessAlert;
